import React, { Component } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  height: 12px;
  padding-right: 5px;
  padding-left: 10px;
  opacity: 1;
  webkit-transition: 0.4s opacity;
  transition: 0.4s opacity;
  webkit-transition-delay: ${props => (props.percent < 100 ? 0 : 0.4)}s;
  transition-delay: ${props => (props.percent < 100 ? 0 : 0.4)}s;
`;

const OuterBar = styled.div`
  display: inline-block;
  width: 100%;
  background-color: ${props => props.color};
  height: 12px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
`;

const InnerBar = styled.div`
  float: ${props => (props.progress === 'right' ? 'right' : 'left')};
  width: ${props => props.percent}%;
  max-width: 100% !important;
  height: 12px;
  background-color: ${props => props.color};
  border-radius: 0 1px 1px 0;
  webkit-transition: 0.4s width, 0.4s background-color;
  transition: 0.4s width, 0.4s background-color;
`;

class ValueBalanceBar extends Component {
  render() {
    return (
      <Container>
        <OuterBar color={this.props.backgroundColor}>
          <InnerBar color={this.props.color} percent={this.props.percent} />
        </OuterBar>
      </Container>
    );
  }
}

ValueBalanceBar.defaultProps = {
  progress: 'right',
  backgroundColor: '#e1e1e1',
  color: '4caf50',
};

export default ValueBalanceBar;
